import axios, { AxiosRequestConfig } from 'axios';
import { getJwtToken } from 'lib/auth/helpers';
import getSBABaseUrl from 'lib/getSBABaseUrl';
import { ChatActionTypes, ChatActionCreators } from './types';

async function getRequestConfig(): Promise<AxiosRequestConfig> {
  const token = await getJwtToken();

  return {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
}

export const chatRequest = (): ChatActionCreators => {
  return { type: ChatActionTypes.REQUEST };
};

export const chatSuccess = (apiResults): ChatActionCreators => {
  const data = apiResults;
  return { type: ChatActionTypes.SUCCESS, data };
};

/* TODO: fix */
export const doAddQaSuccess = (apiResults): ChatActionCreators => {
  const qa = apiResults;
  return { type: ChatActionTypes.ADD_QA_SUCCESS, qa };
};
export const doAddQaFailure = (error): ChatActionCreators => {
  return { type: ChatActionTypes.ADD_QA_FAILURE, error };
};


export const chatFailure = (error): ChatActionCreators => {
  return { type: ChatActionTypes.FAILURE, error };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const doFetchChat = (chatId: string) => {
  return async (dispatch): Promise<void> => {
    dispatch(chatRequest());
    try {
      const { data } = await axios.get(`${getSBABaseUrl()}/api/chats/${chatId}`);
      dispatch(chatSuccess(data));
    } catch (err) {
      if (err.response && err.response.status !== 404) {
        dispatch(chatFailure(err));
      }

    }
  };
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export const doFetchChatByTilstandsrapportId = (tilstandsRapportId: string) => {
  return async (dispatch): Promise<void> => {
    dispatch(chatRequest());
    try {
      const { data } = await axios.get(
        `${getSBABaseUrl()}/api/chats/analyse/${tilstandsRapportId}`,
        await getRequestConfig(),
      );
      dispatch(chatSuccess(data));
    } catch (err) {
      if (err.response && err.response.status !== 404) {
        dispatch(chatFailure(err));
      }
    }
  };
};

export const doCreateChat = (chatId: string, createChatData) => {
  return async (dispatch): Promise<void> => {
    dispatch(chatRequest());
    try {
      const { data } = await axios.post(
        `${getSBABaseUrl()}/api/chats/analyse/${chatId}`,
        createChatData,
        await getRequestConfig(),
      );
      dispatch(chatSuccess(data));
    } catch (err) {
      dispatch(chatFailure(err));
    }
  };
};

export const doCreateQa = (chatId: string, createQaData) => {

  return async (dispatch): Promise<void> => {
    // dispatch(chatRequest());
    try {
      const { data } = await axios.post(
        `${getSBABaseUrl()}/api/chats/${chatId}/qa`,
        createQaData,
        await getRequestConfig(),
      );

      dispatch(doAddQaSuccess(data));
    } catch (err) {
      dispatch(doAddQaFailure(err));
    }
  };
};

export const doAddMessageAsUser = (chatId, addMessageData) => {
  return async (dispatch): Promise<void> => {
    dispatch(chatRequest());
    try {
      const { data } = await axios.put(
        `${getSBABaseUrl()}/api/chats/${chatId}/message`,
        addMessageData,
        await getRequestConfig(),
      );

      dispatch(chatSuccess(data));
    } catch (err) {
      dispatch(chatFailure(err));
    }
  };
};

export const doAddMessageAsParticipant = (chatId, addMessageData) => {
  return async (dispatch): Promise<void> => {
    dispatch(chatRequest());
    try {
      const { data } = await axios.put(`${getSBABaseUrl()}/api/chats/${chatId}/participant/message`, addMessageData);

      dispatch(chatSuccess(data));
    } catch (err) {
      dispatch(chatFailure(err));
    }
  };
};


export const doUpdateParticipantsInChat = (chatId, qaId, reqData) => {
  return async (dispatch): Promise<void> => {
    dispatch(chatRequest());
    try {
      const response = await axios.put(
        `${getSBABaseUrl()}/api/chats/${chatId}/qa/${qaId}/participants`,
        reqData,
        await getRequestConfig(),
      );
      await dispatch(doFetchChat(chatId));
    } catch (err) {
      dispatch(chatFailure(err));
    }
  };
};

export const doUserSeenQA = (chatId, qaId) => {
  return async (dispatch): Promise<boolean> => {
    dispatch(chatRequest());
    try {
      const { data } = await axios.put(
        `${getSBABaseUrl()}/api/chats/${chatId}/qa/${qaId}/seen`,
        {},
        await getRequestConfig(),
      );
      return data;
    } catch (err) {
      return false;
    }
  };
}
